import { render, staticRenderFns } from "./interfaces.vue?vue&type=template&id=258edfa8&scoped=true&"
import script from "./interfaces.vue?vue&type=script&lang=js&"
export * from "./interfaces.vue?vue&type=script&lang=js&"
import style0 from "./interfaces.vue?vue&type=style&index=0&id=258edfa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258edfa8",
  null
  
)

export default component.exports